import { useDispatch, useSelector } from 'react-redux'
import { DataTable, FilterSection, ToolbarComponent } from '../../../../../../components'
import { useGlobal } from '../../../../../../shared'
import { DashboardHead } from '../../../Dashboard/DashboardPage'
// import { InfoField } from '../../School/PopOver/SchoolInfo'
import { FeeInfo, StudentFee } from '../components/FeeInfo'
import { useState } from 'react'
import { urls } from '../../../../../../shared/config'
import { individualfeesHeadCells } from '../../../../../../shared/data/headCells'
import { Toolbar, Typography } from '@mui/material'
import IndividualFeeCard from './IndividualFeeCards'
import React from 'react'
import {
  setOpenExportModalIndividualFee,
  setOpenFeeConfirm,
} from '../../../../../../redux/globalSlice'
import DoubleFees from '../../../../../../common/DoubleFees/DoubleFees'
import classes from './Card.module.css'
import { blueArrow, ImportIcon } from '../../../../../../assets/icons'
import ExportIndividualFeeReport from './ExportIndiviudalFeeReport/ExportIndiviudalFeeReport'

// const feeStatusOptions = [
//   { label: 'UnPaid', value: 'UnPaid' },
//   { label: 'Paid', value: 'Paid' },
//   { label: 'Partial Paid', value: 'Partial Paid' },
// ]
const IndividualStudentFees = ({ setIndividual, userSchoolId }) => {
  // const userSchoolId = localStorage.getItem('userSchoolId')
  // const storedAttributes = localStorage.getItem('userAttributes')
  // const attributes = storedAttributes
  // const customRole = attributes?.employee_type

  const dispatch = useDispatch()
  const [detail, setDetail] = useState(false)
  // const [selectedStatus, setSelectedStatus] = useState('')
  // const [pageFee, setPageFee] = useState(1)
  const [search, setSearch] = useState('')
  // const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const studentID = useSelector((state) => state.global.studentID)
  const feeInfo = useSelector((state) => state.global.openFeeConfirm)
  const openExport = useSelector((state) => state.global.openExportIndividualFee)
  const school_fee_method = localStorage.getItem('school_fee_method')

  // const [schoolName, setSchoolName] = useState('')

  // const api = `${urls.FEES_GET}school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}&page=${pageFee}&limit=${rowsPerPage}`
  // const statusApi = `${urls.FEE_STATUS}${selectedStatus}&page=${pageFee}&limit=${rowsPerPage}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}`
  // const { data: schoolList } = useGlobal({ userUrl: urls.SCHOOL_LIST })

  const {
    data: Data,
    // count,
    totalFee,
    totalPaidFee,
    totalUnpaidFee,
    pendingMonth,
    refetch:individualFeesRefetch
  } = useGlobal({
    userUrl: `${urls.INDIVIDUAL_STUDENT_FEES}${studentID}&fee_method=${school_fee_method}`,
  })
  // console.log('-------data', Data)
  const row = Data

  // const { data: feestatus } = useGlobal({ userUrl: statusApi })

  // const statusFee = feestatus && feestatus?.searchSchoolPayload
  // const { data: searchFee } = useGlobal({
  //   userUrl: `${urls.FEE_SEARCH}${search}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}`,
  // })
  // const row = search ? searchFee : selectedStatus !== '' ? statusFee : feeData
  // const row = search ? searchFee : Data

  // const pagecount = selectedStatus ? feestatus?.countStudent : count
  //   const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  const cardItems = [
    // { title: 'Fees per Month', content: '$100,000', stats: '22.10', },
    // { title: 'Total Fees', content: totalFee?.toFixed(2), stats: '22.10' },
    { title: 'Paid Fees', content: totalPaidFee?.toFixed(2), stats: '32.11' },
    { title: 'Unpaid Fees', content: totalUnpaidFee?.toFixed(2), stats: '62.10' },
  ]
  const handleClose = () => {
    setIndividual(false)
  }
  const handleExportOpen = () => {
    dispatch(setOpenExportModalIndividualFee(true))
  }
  return (
    <div>
      <Toolbar />
      <div className={classes.parents}>
        <div className="school-toolbar">
          <div
            style={{
              width: '44px',
              height: '44px',
            }}
            className="white-ico"
          >
            <img
              src={blueArrow}
              onClick={handleClose}
              style={{
                width: '24px',
                height: '24px',
                transform: 'rotate(-90deg)',
              }}
              className="svg-to-black"
            />
          </div>
        </div>
        <DashboardHead
          profile={Data?.[0]?.student_avatar}
          title={`${Data?.[0]?.student_name}`}
          sec={`${Data?.[0]?.student_grade}-${Data?.[0]?.student_section}`}
          subtitle={`Dashboard / Fees / ${Data?.[0]?.student_name}`}
        />
      </div>

      {/* <div className={classes.boxes}>
        {feesData.map((value, index ) => {
          return (
            <div key={index} className={classes.box}>
              <div className={classes.lhs}>

              </div>
              <div className={classes.iconframe}>
                <img src={calculator} alt="FSM"  />
              </div>
            </div>
          )
        })}
      </div> */}
      <div className="dashboard-cards">
        <DoubleFees totalFees={totalFee?.toFixed(2)} feePerMonth={(totalFee/12)?.toFixed(2)} />
        {cardItems.map((card, index) => (
          <IndividualFeeCard
            key={index}
            title={card.title}
            content={card.content}
            stats={card.stats}
            // cardItems={cardItems}
            index={index}
            pendingMonth={pendingMonth}
          />
        ))}
      </div>
      <ToolbarComponent
        search={search}
        setSearchItem={setSearch}
        individualfee
        btnText={'Collect Fee'}
        handleOpen={() => dispatch(setOpenFeeConfirm(true))}
      >
        {/* <SelectPopUp
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          selectOptions={feeStatusOptions}
        /> */}
        {/* <FilterSection icon={FilterIcon} title={'Filter'} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExportOpen} title={'Export'} />
      </ToolbarComponent>
      <DataTable
        rowData={row}
        headCells={individualfeesHeadCells}
        individualfee
        handleDetailOpen={() => setDetail(true)}
      />
      {detail && <FeeInfo open={detail} handleClose={() => setDetail(false)} />}
      {feeInfo && (
        <StudentFee
          open={feeInfo}
          individualfees={true}
          handleClose={() => dispatch(setOpenFeeConfirm(false))}
          userSchoolId={userSchoolId}
          refetch={individualFeesRefetch}
        />
      )}
      {openExport && <ExportIndividualFeeReport open={openExport} />}
    </div>
  )
}

export default IndividualStudentFees
